import { setUserAction, withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import InvestorKycDialog from './InvestorKycDialog';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Kyc from '../../../ExternalInvestApi/Kcx';
import FundAmerica from '../../../ExternalInvestApi/FundAmerica';

class InvestorKycAction extends Component {
  state = {
    acuantStatus: false,
    displayDialog: false,
  };

  handleDialogClose = () => {
    this.setState({ displayDialog: false });
  };

  request = async (variables) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      mutation,
      dispatch,
      showKycConfirmText,
    } = this.props;
    const { mutate } = client;

    const input = {
      ...variables,
    };

    try {
      const {
        data: { investorKycRequest: result },
      } = await mutate({ mutation, variables: { input } });

      dispatch(setUserAction(result));

      const { kycStatus, appId } = result;

      if (kycStatus === 'ACCEPTED') {
        dispatch(setUserAction({ showInvestmentForm: true }));
        setSnackbarMessage('KYC Verification Request sent');
        dispatch(setUserAction({ showDocxForm: true, kycAppId: appId }));
        showKycConfirmText();
      } else if (kycStatus === 'UNDER_REVIEW') {
        this.setState({ displayDialog: true });
        dispatch(setUserAction({ showDocxForm: true, kycAppId: appId }));
        // setSnackbarMessage(
        //   'Your KYC Verification Request requires further review, we will be in touch shortly.'
        // );
      } else {
        setSnackbarMessage(
          'Your KYC Verification Request has been rejected, please check your information and try again.'
        );
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };

  render() {
    const {
      title,
      disabled,
      open,
      handleClickOpen,
      handleClose,
      offerId,
      accreditted,
      offer,
    } = this.props;

    const MySwal = withReactContent(Swal);
    if (
      accreditted &&
      (offer.typeOfOffer === 'REG_D' ||
        offer.typeOfOffer === 'Reg_D_506b' ||
        offer.typeOfOffer == 'Reg_D_506c') &&
      open
    ) {
      return MySwal.fire({
        title: 'Thank you for your interest in this Offer',
        text: ' This deal is for Accredited Investors only please review your Accreditation status in your Account Profile.',
        icon: 'error',
        confirmButtonColor: '#808080',
        cancelButtonColor: '#d33',
        showCancelButton: true,
        confirmButtonText: `Review`,
        cancelButtonText: `Continue`,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/account/qualification';
        } else if (result.isDismissed) {
          window.location.href = '/dashboard/all-offers';
        }
      });
    } else {
      return (
        <Fragment>
          <Dialog open={this.state.displayDialog}>
            <DialogContent>
              <DialogContentText>
                Your KYC Verification Request requires further review, we will
                be in touch shortly.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleDialogClose}
                className='action-button'
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <InvestorKycDialog
            open={open}
            disabled={disabled}
            handleClose={handleClose}
            request={this.request}
            title='Investor KYC Verification'
            offerId={offerId}
          />

          {offer.typeOfOffer === 'REG_A' && offer.processType === 'KORECONX' ? (
            <Kyc />
          ) : offer.typeOfOffer === 'REG_A' &&
            offer.processType === 'FUNDAMERICA' ? (
            <FundAmerica />
          ) : (
            <button
              onClick={handleClickOpen}
              className='button small w-button'
              style={{ width: 'inherit', marginRight: 10 }}
            >
              {title}
            </button>
          )}
        </Fragment>
      );
    }
  }
}

InvestorKycAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClickOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  accreditted: PropTypes.bool,
  offer: PropTypes.object,
};

InvestorKycAction.defaultProps = {
  disabled: false,
  offer: null,
};

export default connect()(withApollo(withAlertHandler(InvestorKycAction)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/InvestorKyc/InvestorKycAction.js